import { DeviceModel } from '@lmt/shared-types';

export interface Option {
  value: number;
  displayValue: string;
}

export const deviceModels: Option[] = [
  {
    value: DeviceModel.MiniScreen,
    displayValue: 'MiniScreen',
  },
];
